var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBusinessTarget = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 18,
  viewBox: "0 0 25 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M24.064 6v3a1 1 0 0 1-1 1H19.74a1 1 0 0 1-.929-.628l-.548-1.371H9.972c.059.16.09.329.092.5a1.5 1.5 0 1 1-1.5-1.5h1.989a2.49 2.49 0 1 0 .46 2h2a4.536 4.536 0 1 1-.244-2h1.083a5.498 5.498 0 1 0 .186 2h3a8.526 8.526 0 1 1-.124-2h1.35l.548-1.372a1 1 0 0 1 .929-.628h3.323a1 1 0 0 1 1 1Z"
})));
export default SvgBusinessTarget;